import { cn } from '@/utils/tailwind';

interface ResizeHandleProps {
  dragging: boolean;
  onMouseDown: (e: React.PointerEvent<HTMLDivElement>) => void;
  onMouseUp: () => void;
}

export function ResizeHandle({
  dragging,
  onMouseDown,
  onMouseUp,
}: ResizeHandleProps) {
  return (
    <div
      className="group absolute bottom-0 left-0 right-0 h-[10px] cursor-ns-resize"
      style={{ width: '100%' }}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
    >
      <div
        className={cn(
          'absolute inset-x-0 -bottom-[0.5px] z-10 h-[2px] bg-tertiary opacity-0 transition-all group-hover:opacity-100',
          dragging && 'bg-brand-green-400 opacity-100'
        )}
      />
      <div className="absolute inset-x-0 -bottom-[4px] z-10 h-[9px] opacity-0" />
    </div>
  );
}
